<!--
 * @Author: 月魂
 * @Date: 2021-01-29 10:14:49
 * @LastEditTime: 2022-01-26 15:21:30
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\Warriors.vue
-->
<template>
  <div class="cont">
    <Header title="warriors" />
    <!-- 弹出视频 -->
    <van-overlay v-if="show" :show="show" @click="show = false">
      <div class="wrapper">
        <video
          src="http://image.wearetogether.com.cn/warriors-fir.mp4"
          poster="http://cdn.topartsintermational.com/warriors-video-bg-ser.jpg"
          controls
          width="100%"
          style="display: block"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <van-overlay v-if="visible" :show="visible" @click="visible = false">
      <div class="wrapper">
        <video
          src="http://cdn.topartsintermational.com/warriors-1.mp4"
          poster="http://cdn.topartsintermational.com/warriors-1-bg.jpg"
          controls
          style="display: block; width: 100%; object-fit: fill"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <img
      src="http://image.wearetogether.com.cn/warriors-ukraine-n.jpg"
      width="100%"
    />
    <!-- part1 -->
    <div style="padding: 10px">
      <img
        src="http://cdn.topartsintermational.com/warriors-img1.jpg"
        width="100%"
        style="margin-top: 16px"
      />
    </div>
    <div class="part1-text">
      <p>{{ setting.part1.des }}</p>
    </div>
    <!-- part2 -->
    <img
      src="http://cdn.topartsintermational.com/hisLine.png"
      width="100%"
      style="margin-top: 16px"
    />
    <div class="part2">
      <div class="title">{{ setting.part2.title }}</div>
      <p style="color: #f2f2f2">
        {{ setting.part2.des }}
      </p>
      <div class="part2-cont">
        <p>{{ setting.part2.cont }}</p>
      </div>
    </div>
    <!-- part3 -->
    <div class="part3">
      <a
        class="part3-left"
        href="http://www.bmy.com.cn/html/public/zl/500yvr/bc726d2972a949c180c4f85216e6c5ea.html"
        target="_blank"
      >
        <p>{{ setting.partLeft.title }}</p>
        <p>{{ setting.partLeft.des }}</p>
      </a>
      <a
        class="part3-right"
        href="http://www.bmy.com.cn/html/public/zl/500yvr/bc726d2972a949c180c4f85216e6c5ea.html"
        target="_blank"
      >
        <p>{{ setting.partRight.title }}</p>
        <p>{{ setting.partRight.des }}</p>
      </a>
    </div>
    <!-- part4 -->
    <img
      src="http://cdn.topartsintermational.com/hisLine.png"
      width="100%"
      style="margin-top: 16px"
    />
    <div class="part4">
      <div class="title" style="font-size: 18px">{{ setting.part4.title }}</div>
      <p style="color: #f2f2f2">
        {{ setting.part4.des }}
      </p>
      <div class="part4-cont">
        <div class="part4-cont-left">
          <p>
            {{ setting.part4.cont }}
          </p>
        </div>
        <div class="part4-cont-right" @click="visible = true">
          <img
            src="http://cdn.topartsintermational.com/warriors-img7.jpg"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
export default {
  name: 'Warriors',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      setting: {
        part1: {
          des: this.$t('message.warriors.part1.des'),
        },
        part2: {
          title: this.$t('message.warriors.part2.title'),
          des: this.$t('message.warriors.part2.des'),
          cont: this.$t('message.warriors.part2.cont'),
        },
        partLeft: {
          title: this.$t('message.warriors.partLeft.title'),
          des: this.$t('message.warriors.partLeft.des'),
        },
        partRight: {
          title: this.$t('message.warriors.partRight.title'),
          des: this.$t('message.warriors.partRight.des'),
        },
        part4: {
          title: this.$t('message.warriors.part4.title'),
          des: this.$t('message.warriors.part4.des'),
          cont: this.$t('message.warriors.part4.cont'),
        },
      },
      show: true,
      visible: false,
    }
  },
}
</script>

<style scoped lang="less">
.cont {
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
  background: url("http://cdn.topartsintermational.com/warriors-bg.jpg")
    no-repeat;
  background-size: cover;
  .part1-text {
    background: url("http://cdn.topartsintermational.com/warriors-img2.jpg")
      no-repeat;
    background-size: contain;
    padding: 10px 10px 0;
    background-color: #771f1f;
    margin-top: 16px;
    p {
      color: #fff;
      line-height: 1.8;
      text-indent: 2em;
    }
  }
  .part2 {
    text-align: center;
    color: #fff;
    line-height: 1.8;
    h1 {
      margin: 0;
      padding: 0;
    }
    .part2-cont {
      background: url("http://cdn.topartsintermational.com/warriors-img3.jpg")
        no-repeat;
      background-size: cover;
      text-indent: 2em;
      color: #efeaea;
      line-height: 1.8;
      text-align: justify;
      margin-top: 8px;
      p {
        margin: 0;
        padding: 26px 10px 0;
      }
    }
  }
  .part3 {
    color: #fff;
    line-height: 1.8;
    p {
      margin: 0;
      text-align: center;
    }
    .part3-left {
      display: block;
      width: 100%;
      background: url("http://cdn.topartsintermational.com/warriors-img4.jpg")
        no-repeat;
      background-size: cover;
      text-decoration: none;
      color: #efeaea;
      padding: 0 10px;
    }
    .part3-right {
      display: block;
      width: 100%;
      background: url("http://cdn.topartsintermational.com/warriors-img5.jpg")
        no-repeat;
      background-size: cover;
      text-decoration: none;
      color: #efeaea;
    }
  }
  .part4 {
    text-align: center;
    color: #fff;
    line-height: 1.8;
    h1 {
      margin: 0;
      padding: 0;
      line-height: 1.8;
    }
    .part4-cont-left {
      background: url("http://cdn.topartsintermational.com/warriors-img6.jpg")
        no-repeat;
      background-size: cover;
      text-align: justify;
      p {
        line-height: 1.8;
        text-indent: 2.8em;
        padding: 36px 10px 16px;
      }
    }
    .part4-cont-right {
      overflow: hidden;
    }
  }
}
</style>